import { array, integer, object, optional, string } from 'superstruct';
export function ListResourceDto(struct) {
  return object({
    items: array(struct),
    meta: object({
      totalItems: integer(),
      itemsPerPage: integer(),
      page: integer(),
      timestamp: optional(string())
    })
  });
}